///<reference path='../../../WebUI/typings/tsd.d.ts'/>
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Environment } from "../../Utils/Environment";

export class FooterControlProps {
    scrollingClass?: string;
    fixed?: boolean;
    tosUrl?: string;
}

export interface FooterControlState {
    fixed?: boolean;
    wantUpdates?: boolean;
}

export class FooterControl extends React.Component<FooterControlProps, FooterControlState> {
    fixed: HTMLElement;
    floating: HTMLElement;
    base: HTMLElement;
    scrollHandler: any;
    scrollingElement: JQuery;

    constructor(props: FooterControlProps) {
        super(props);
        this.state = {
            fixed: this.props.fixed,
            wantUpdates: !this.props.hasOwnProperty("fixed")
        }
    }

    public static defaultProps: Partial<FooterControlProps> = {
        tosUrl: '//aka.ms/bf-terms'
    };

    private initFixed(element: HTMLElement) {
        this.fixed = element;
        this.initCommon();
    }

    private initFloating(element: HTMLElement) {
        this.floating = element;
        this.initCommon();
    }

    private initBase(element: HTMLElement) {
        this.base = element;
        this.initCommon();
    }

    private initCommon() {
        if (this.state.wantUpdates && this.base && this.fixed && this.floating) {
            if (this.props.scrollingClass) {
                this.scrollingElement = $(this.props.scrollingClass);
            }
            else {
                this.scrollingElement = $(this.base).parent();
            }
            if (this.scrollingElement) {
                this.scrollHandler = _.debounce(() => this.update(), 50, false);
                this.scrollingElement.on("scroll", this.scrollHandler);
                window.addEventListener("resize", this.scrollHandler);
                this.update();
            }
        }
    }

    public update() {
        if (!this.state.wantUpdates || !this.floating || !this.fixed || !this.base)
            return;
        let prev = $(this.base).prev();
        let footer = $(this.floating);
        if (footer && prev && prev.offset()) {
            // Get the vertical offset to the bottom of the non-fixed footer.
            let prevTop = prev.offset().top;
            let prevHeight = prev.outerHeight();
            let footerHeight = footer.outerHeight();
            let padding = 20; // There is a mystery gap in the measurement calculation. This compensates for it.
            if (window.innerHeight - (prevTop + prevHeight + footerHeight + padding) > 0) {
                // If the footer is completely visible, show as fixed.
                this.showFixed();
            } else {
                // If the footer is at all below the window edge, show non-fixed.
                this.showFloating();
            }
        } else {
            // Default to fixed until we have everything we need in order to do the calculation above.
            this.showFixed();
        }
    }

    private showFloating() {
        if (this.state.fixed)
            this.setState({fixed: false});
    }

    private showFixed() {
        if (!this.state.fixed)
            this.setState({fixed: true});
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.scrollHandler);
        if (this.scrollingElement) {
            this.scrollingElement.off("scroll", this.scrollHandler);
        }
    }

    public render(): JSX.Element {
        // Hide the entire footer in Ibiza
        if (Environment.isInBotFrameworkAzureExtension) {
            return null;
        }

        const additional = [
            Environment.isInAzurePortal ? null : <li key="terms"><a href={this.props.tosUrl} target="_blank">Terms of use</a></li>
        ];
        const content = [
            <ul key="footer-items">
                <li key="contact"><a href="//aka.ms/bf-contactus" target="_blank">Contact us</a></li>
                <li key="private"><a href="//aka.ms/bf-privacy" target="_blank">Privacy & cookies</a></li>
                {this.props.children}
                {additional}
                <li key="copyright">{"\u00a9 2019 Microsoft"}</li>
            </ul>
        ]

        const fixedDisplay = (this.state.fixed ? "block" : "none");
        const floatingDisplay = (this.state.fixed ? "none" : "block");
        return (
            <div className="site-footer" ref={x => this.initBase(x)}>
                <div className="outline footer fixed" style={{ display: fixedDisplay }} ref={x => this.initFixed(x)}>{content}</div>
                <div className="outline footer floating" style={{ display: floatingDisplay }} ref={x => this.initFloating(x)}>{content}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/v4/FooterControl.tsx